import React from 'react'
import colors from 'styles/colors'
import BoxWithBorder from 'components/atoms/container/BoxWithBorder'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined'
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import CircularProgressBar from 'components/atoms/CircularProgressBar'
import { Box, useTheme } from '@mui/material'

const buttonColorOptions = [
  colors.GoldenYellow400,
  colors.Watermelon400,
  colors.Peach400
]

export const getColorByIndex = i => {
  const colorIndex = i % 3
  return buttonColorOptions[colorIndex]
}

const RoundIcon = ({ icon, color = colors.Grey300, containerSx = {} }) => (
  <BoxWithBorder
    sx={{
      height: 27,
      width: 27,
      borderColor: colors.Grey300,
      backgroundColor: colors.White,
      borderWidth: 1,
      borderRadius: 20,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 1,
      ...containerSx
    }}>
    {React.cloneElement(icon, { style: { color, fontSize: 19 } })}
  </BoxWithBorder>
)

export const Level1IconButton = ({
  completed,
  active,
  percentComplete,
  lastL1Step
}) => {
  const theme = useTheme()
  return (
    <>
      {completed ? (
        <CheckCircleRoundedIcon
          color='secondary'
          sx={{
            fontSize: 40
          }}
        />
      ) : active ? (
        <Box
          sx={{
            height: 40,
            width: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <CircularProgressBar
            value={percentComplete}
            barColor={theme.palette.secondary.main}
            backgroundColor={colors.White}
            containerSx={{ height: 52, width: 52 }}
            labelStyle={{ fontSize: 90, fontWeight: 600, color: 'primary' }}
          />
          <Box sx={{
            height: 40,
            width: 40,
            borderColor: theme.palette.secondary.main,
            borderWidth: percentComplete === 0 ? 1 : 0,
            borderStyle: 'solid',
            borderRadius: 20,
            position: 'absolute'
          }}>

          </Box>
        </Box>
      ) : lastL1Step ? (
        <FlagOutlinedIcon
          sx={{
            color: colors.Grey300,
            fontSize: 40
          }}
        />
      ) : (
        <RoundIcon
          icon={<LockOutlinedIcon />}
          containerSx={{
            height: 40,
            width: 40
          }}
        />
      )}
    </>
  )
}

export const Level2IconButton = ({
  completed = false,
  active = false,
  learningCheck = false
}) => {
  const theme = useTheme()
  return (
    <>
      {active ? (
        <RoundIcon
          icon={<ArrowForwardOutlinedIcon color='secondary' />}
          color='secondary'
          containerSx={{
            borderColor: theme.palette.secondary.main,
            backgroundColor: colors.GoldenYellow50
          }}
        />
      ) : completed ? (
        <CheckCircleRoundedIcon
          color='secondary'
          sx={{
            fontSize: 32
          }}
        />
      ) : learningCheck ? (
        <RoundIcon icon={<PsychologyAltOutlinedIcon />} />
      ) : (
        <RoundIcon icon={<LockOutlinedIcon />} />
      )}
    </>
  )
}
